import { configureApiClient } from "@profitlens/api-client";

import i18n from "@/i18n";
import { toast } from "@profitlens/ui/toast";
import { useAuthStore } from "@/stores/auth-store";

/**
 * Wires the transport layer to the auth store. Must run before the first render.
 *
 * - access token: in-memory only (Zustand), attached as `Authorization: Bearer`
 * - refresh token: httpOnly cookie `pl_refresh`, sent automatically (credentials: include)
 * - 401 -> one single-flight refresh -> replay, handled inside the transport
 * - refresh gone -> expire the session; the router sends the user to /login
 */
export function configureApi(): void {
  const baseUrl = `${import.meta.env.VITE_API_BASE ?? "/api"}/v1`;

  configureApiClient({
    baseUrl,
    getAccessToken: () => useAuthStore.getState().accessToken,
    setAccessToken: (token) => useAuthStore.getState().setAccessToken(token),
    onSessionExpired: () => {
      const { status, expire } = useAuthStore.getState();
      if (status !== "authenticated") return;
      expire();
      toast({
        title: i18n.t("auth.sessionExpired"),
        variant: "warning",
      });
    },
  });
}
